import { ASADO_BASE_URLS as baseUrls } from '../utils/api';

export const getToastByKey = async (key: string, env: 'dev' | 'prod') => {
  try {
    const response = await fetch(`${baseUrls[env]}/public/cms/sanity/toasts/${key}`);
    const responseJson = await response.json();
    return responseJson;
  } catch (error: unknown) {
    throw new Error(error as string);
  }
};
